// File: src/components/NonLoggedInEventsLanding.jsx
import React, { useState } from "react";
import { LuInstagram, LuLinkedin, LuLogIn } from "react-icons/lu";
import NonLoggedInHero from "./landing/NonLoggedInHero";
import HowItWorksSection from "./landing/HowItWorksSection";
import GatheringsSection from "./landing/GatheringsSection";
import HostWithTribeSection from "./landing/HostWithTribeSection";
import FaqSection from "./landing/FaqSection";
import OurStorySection from "./landing/OurStorySection";
import ScrollJoinBar from "./landing/ScrollJoinBar";
import PortalLoginModal from "./host/modals/PortalLoginModal";
import { ReactComponent as TribeLogo } from "../assets/TribeLogo.svg";
export default function NonLoggedInEventsLanding({
  events = [],
  onSeeGatherings,
  onEventClick,
}) {
  const [portalLoginOpen, setPortalLoginOpen] = useState(false);
  const scrollToSection = (event, id) => {
    // Preserve standard link behavior for modified clicks.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const section = document.getElementById(id);
    if (!section) return;
    event.preventDefault();
    section.scrollIntoView({
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "auto"
        : "smooth",
      block: "start",
    });
  };
  return (
    <main className="nonloggedLanding" style={styles.page}>
      <style>{`
        .desktopLandingNav { display: flex; }
        .desktopLandingNav__actions {
          display: flex;
          align-items: center;
          gap: 24px;
          flex-shrink: 0;
        }
        .desktopLandingNav__story {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 40px;
          padding: 0;
          color: #171717;
          font-family: inherit;
          font-size: 13px;
          font-weight: 600;
          line-height: 1.2;
          text-decoration: none;
          text-underline-offset: 5px;
          white-space: nowrap;
        }
        .desktopLandingNav__story:hover {
          text-decoration: underline;
          text-decoration-thickness: 1px;
        }
        .desktopLandingNav :is(a, button):focus-visible,
        .desktopLandingFooter :is(a, button):focus-visible {
          outline: 2px solid #343c54;
          outline-offset: 4px;
        }
        .desktopLandingFooter {
          position: relative;
          isolation: isolate;
          overflow: hidden;
          display: block;
          background: #fff;
          color: #171717;
          border-top: 1px solid rgba(17,17,17,0.1);
          font-family: inherit;
        }
        .desktopLandingFooter::before {
          content: "";
          position: absolute;
          inset: -50%;
          z-index: -1;
          pointer-events: none;
          opacity: 0.05;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http\://www.w3.org/2000/svg' width='180' height='180' viewBox='0 0 180 180'%3E%3Cfilter id='grain'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.92' numOctaves='3' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Cpath fill='%23000' filter='url(%23grain)' d='M0 0h180v180H0z'/%3E%3C/svg%3E");
          background-repeat: repeat;
          background-size: 180px 180px;
        }
        .desktopLandingFooter__inner {
          width: 100%;
          max-width: 1180px;
          margin: 0 auto;
          padding: 54px 28px 22px;
          box-sizing: border-box;
          position: relative;
          z-index: 1;
        }
        .desktopLandingFooter__top {
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(150px, 0.65fr) minmax(170px, 0.75fr);
          gap: clamp(36px, 7vw, 100px);
          align-items: start;
        }
        .desktopLandingFooter__brand { max-width: 390px; }
        .desktopLandingFooter__mission {
          margin: 20px 0 8px;
          color: #343c54;
          font-size: 11px;
          font-weight: 650;
          line-height: 1.35;
          letter-spacing: 0.075em;
          text-transform: uppercase;
        }
        .desktopLandingFooter__description {
          max-width: 380px;
          margin: 0;
          color: #555;
          font-size: 14px;
          font-weight: 400;
          line-height: 1.65;
          letter-spacing: -0.008em;
        }
        .desktopLandingFooter__label {
          margin: 5px 0 18px;
          color: #74736e;
          font-size: 10px;
          font-weight: 650;
          line-height: 1.2;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }
        .desktopLandingFooter__nav {
          display: grid;
          justify-items: start;
          gap: 12px;
        }
        .desktopLandingFooter__link {
          color: #4e4d49;
          font-size: 13px;
          line-height: 1.3;
          text-decoration: none;
          text-underline-offset: 4px;
          transition: color 160ms ease;
        }
        .desktopLandingFooter__link:hover {
          color: #171717;
          text-decoration: underline;
        }
        .desktopLandingFooter__socialLink {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          color: #4e4d49;
          font-size: 13px;
          line-height: 1.3;
          text-decoration: none;
          transition: color 160ms ease;
        }
        .desktopLandingFooter__socialLink:hover { color: #171717; }
        .desktopLandingFooter__socialLink svg {
          width: 16px;
          height: 16px;
          color: #343c54;
        }
        .desktopLandingFooter__bottom {
          margin-top: 46px;
          padding-top: 18px;
          border-top: 1px solid rgba(17,17,17,0.12);
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
        }
        .desktopLandingFooter__copyright {
          margin: 0;
          color: #77756f;
          font-size: 11px;
          line-height: 1.4;
        }
        .desktopLandingFooter__legal {
          display: flex;
          align-items: center;
          gap: 11px;
        }
        .desktopLandingFooter__legal .desktopLandingFooter__link {
          color: #77756f;
          font-size: 11px;
        }
        .desktopLandingFooter__legal .desktopLandingFooter__link:hover { color: #171717; }
        .desktopLandingFooter__dot {
          color: #aaa79f;
          font-size: 11px;
          user-select: none;
        }
        @media (min-width: 441px) and (max-width: 700px) {
          .desktopLandingNav {
            height: auto !important;
            min-height: 76px;
            flex-wrap: wrap;
            column-gap: 16px;
            row-gap: 4px;
          }
          .desktopLandingNav__actions {
            gap: 12px;
            flex-wrap: wrap;
            justify-content: flex-end;
            margin-left: auto;
            max-width: 100%;
          }
          .desktopLandingFooter__inner {
            padding: 42px 22px 20px;
          }
          .desktopLandingFooter__top {
            grid-template-columns: 1fr 1fr;
            grid-template-areas: "brand brand" "explore social";
            gap: 30px 24px;
          }
          .desktopLandingFooter__brand { grid-area: brand; }
          .desktopLandingFooter__explore { grid-area: explore; }
          .desktopLandingFooter__social { grid-area: social; }
          .desktopLandingFooter__bottom {
            margin-top: 34px;
            align-items: flex-start;
          }
        }
        @media (max-width: 440px) {
          .desktopLandingNav,
          .desktopLandingFooter { display: none !important; }
        }
        @media (min-width: 441px) {
          .landingScrollCta {
            display: none !important;
          }
        }
        .desktopLandingLogoBlack :is(path,circle,rect,polygon,polyline,ellipse) {
          fill: #050505 !important;
        }
        .desktopLandingLogoBlack [fill="none"] { fill: none !important; }
        .desktopLandingLogoBlack * { stroke: none !important; }
        .desktopLandingLogoFooter :is(path,circle,rect,polygon,polyline,ellipse) {
          fill: #000 !important;
        }
        .desktopLandingLogoFooter [fill="none"] { fill: none !important; }
        .desktopLandingLogoFooter * { stroke: none !important; }
        @media (prefers-reduced-motion: reduce) {
          .desktopLandingFooter__link,
          .desktopLandingFooter__socialLink { transition: none; }
        }
      `}</style>
      <header className="desktopLandingNav" style={styles.nav}>
        <button
          type="button"
          style={styles.logoButton}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Back to top"
        >
          <TribeLogo className="desktopLandingLogoBlack" style={styles.logoSvg} />
        </button>
        <nav className="desktopLandingNav__actions" aria-label="Main navigation">
          <a
            href="#our-story"
            className="desktopLandingNav__story"
            onClick={(event) => scrollToSection(event, "our-story")}
          >
            Our story
          </a>
          <a
            href="#how-it-works"
            className="desktopLandingNav__story"
            onClick={(event) => scrollToSection(event, "how-it-works")}
          >
            How it works
          </a>
          <a
            href="#faq"
            className="desktopLandingNav__story"
            onClick={(event) => scrollToSection(event, "faq")}
          >
            FAQ
          </a>
          <button
            type="button"
            style={styles.portalLoginBtn}
            onClick={() => setPortalLoginOpen(true)}
          >
            <LuLogIn size={14} strokeWidth={2.4} />
            Portal login
          </button>
        </nav>
      </header>
      <NonLoggedInHero onSeeGatherings={onSeeGatherings} />
      <HowItWorksSection />
      <GatheringsSection
        events={events}
        onSeeGatherings={onSeeGatherings}
        onEventClick={onEventClick}
      />
      <OurStorySection />
      <HostWithTribeSection />
      <div id="faq">
        <FaqSection />
      </div>
      <footer className="desktopLandingFooter">
        <div className="desktopLandingFooter__inner">
          <div className="desktopLandingFooter__top">
            <div className="desktopLandingFooter__brand">
              <TribeLogo
                className="desktopLandingLogoFooter"
                style={styles.footerLogoSvg}
                aria-label="Tribe"
              />
              <p className="desktopLandingFooter__mission">Make loneliness an option.</p>
              <p className="desktopLandingFooter__description">
                Tribe plans and hosts small, activity-led gatherings where people meet in person,
                share an experience, and build meaningful connections.
              </p>
            </div>
            <nav
              className="desktopLandingFooter__explore desktopLandingFooter__nav"
              aria-label="Explore Tribe"
            >
              <p className="desktopLandingFooter__label">Explore</p>
              <a className="desktopLandingFooter__link" href="#our-story">Our story</a>
              <a className="desktopLandingFooter__link" href="#how-it-works">How it works</a>
              <a className="desktopLandingFooter__link" href="#faq">FAQ</a>
            </nav>
            <nav
              className="desktopLandingFooter__social desktopLandingFooter__nav"
              aria-label="Follow Tribe"
            >
              <p className="desktopLandingFooter__label">Follow along</p>
              <a
                className="desktopLandingFooter__socialLink"
                href="https\://www.instagram.com/jointribe.io/"
                target="\_blank"
                rel="noreferrer"
              >
                <LuInstagram aria-hidden="true" />
                Instagram
              </a>
              <a
                className="desktopLandingFooter__socialLink"
                href="https\://www.linkedin.com/company/82302259"
                target="\_blank"
                rel="noreferrer"
              >
                <LuLinkedin aria-hidden="true" />
                LinkedIn
              </a>
            </nav>
          </div>
          <div className="desktopLandingFooter__bottom">
            <p className="desktopLandingFooter__copyright">
              © 2026 Tribe LLC. All rights reserved.
            </p>
            <nav className="desktopLandingFooter__legal" aria-label="Legal">
              <a className="desktopLandingFooter__link" href="/terms">Terms of Service</a>
              <span className="desktopLandingFooter__dot" aria-hidden="true">·</span>
              <a className="desktopLandingFooter__link" href="/privacy">Privacy Policy</a>
            </nav>
          </div>
        </div>
      </footer>
      <ScrollJoinBar />
      <PortalLoginModal open={portalLoginOpen} onClose={() => setPortalLoginOpen(false)} />
    </main>
  );
}
const styles = {
  page: {
    minHeight: "100vh",
    background: "#fff",
    color: "#171717",
    fontFamily: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    overflowX: "hidden",
  },
  nav: {
    height: 76,
    maxWidth: 1180,
    margin: "0 auto",
    padding: "0 28px",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
  },
  logoButton: {
    padding: 0,
    border: "none",
    background: "transparent",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  logoSvg: { width: 88, height: "auto", display: "block" },
  portalLoginBtn: {
    height: 40,
    padding: "0 14px",
    borderRadius: 999,
    border: "1px solid rgba(17,17,17,0.12)",
    background: "#fff",
    color: "#111",
    fontSize: 13,
    fontWeight: 760,
    letterSpacing: "-0.02em",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 7,
    whiteSpace: "nowrap",
  },
  footerLogoSvg: { display: "block", width: 76, height: "auto", color: "#000" },
};
